module.exports = __webpack_public_path__ + "static/topup-bg-8d16b8ed78c2ebaedf792235c5a16d65.png";